import { Alert } from "@vericus/cadmus-ui";

import { useAppSelector } from "@/data/hooks";

import { selectRecordingStartCutoffDatePassed } from "../socratic-slice";

export function RecordingStartCutoffTip({
  isFirstAttempt,
  hasAutoSubmission,
}: {
  isFirstAttempt: boolean;
  hasAutoSubmission: boolean;
}) {
  const recordingStartCutoffDatePassed = useAppSelector(
    selectRecordingStartCutoffDatePassed
  );

  if (
    recordingStartCutoffDatePassed == null ||
    recordingStartCutoffDatePassed === false
  ) {
    return null;
  }

  if (hasAutoSubmission) {
    return (
      <Alert severity="error" size="sm">
        {isFirstAttempt && (
          <>There is not enough time left to start an attempt.</>
        )}
        {!isFirstAttempt && <>There is not enough time left to reattempt.</>}
      </Alert>
    );
  }

  return (
    <Alert severity="warning" size="sm">
      {isFirstAttempt && (
        <>
          <div>There is not enough time left to complete an attempt.</div>
          <div>
            You may still start an attempt, but you will not be able to submit
            on time.
          </div>
        </>
      )}
      {!isFirstAttempt && (
        <>
          <div>There is not enough time left to reattempt.</div>
          <div>
            You may still start an attempt, but you will not be able to submit
            on time.
          </div>
        </>
      )}
    </Alert>
  );
}
